var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
var CursorType;
(function (CursorType) {
    CursorType["MIN"] = "MIN";
    CursorType["MAX"] = "MAX";
})(CursorType || (CursorType = {}));
export default function DoubleSlider(_a) {
    var minThreshold = _a.minThreshold, maxThreshold = _a.maxThreshold, gap = _a.gap, minValue = _a.minValue, maxValue = _a.maxValue, setMinValue = _a.setMinValue, setMaxValue = _a.setMaxValue;
    var _b = useState(undefined), dragging = _b[0], setDragging = _b[1];
    var _c = useState({ left: 0, width: 0 }), rect = _c[0], setRect = _c[1];
    var _d = useState(null), activeCursor = _d[0], setActiveCursor = _d[1];
    useEffect(function () {
        function handleMove(event) {
            var _a;
            if (!dragging)
                return;
            var clientX = event instanceof MouseEvent ? event.clientX : ((_a = event.touches[0]) === null || _a === void 0 ? void 0 : _a.clientX) || 0;
            var ratio = (clientX - rect.left) / rect.width;
            var newValue = getValueFromRatio(ratio);
            if (dragging === CursorType.MIN) {
                if (newValue <= maxValue)
                    setMinValue(newValue);
            }
            else if (dragging === CursorType.MAX) {
                if (newValue >= minValue)
                    setMaxValue(newValue);
            }
        }
        function handleUp() {
            setDragging(undefined);
        }
        if (dragging) {
            window.addEventListener('mousemove', handleMove);
            window.addEventListener('mouseup', handleUp);
            window.addEventListener('touchmove', handleMove);
            window.addEventListener('touchend', handleUp);
        }
        return function () {
            window.removeEventListener('mousemove', handleMove);
            window.removeEventListener('mouseup', handleUp);
            window.removeEventListener('touchmove', handleMove);
            window.removeEventListener('touchend', handleUp);
        };
    }, [dragging, rect, minValue, maxValue]);
    function getValueRatio(value) {
        if (value < minThreshold || value > maxThreshold)
            return 0;
        return (value - minThreshold) / (maxThreshold - minThreshold);
    }
    function getValueFromRatio(ratio) {
        if (ratio < 0)
            return minThreshold;
        if (ratio > 1)
            return maxThreshold;
        return Math.round((minThreshold + (maxThreshold - minThreshold) * ratio) / gap) * gap;
    }
    function handleDown(event, type) {
        var _a;
        var sliderBar = (_a = event.currentTarget.parentElement) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (sliderBar) {
            setRect({ left: sliderBar.left, width: sliderBar.width });
            setDragging(type);
            setActiveCursor(type);
        }
    }
    var left = getValueRatio(minValue);
    var right = getValueRatio(maxValue);
    return (_jsx(Container, { children: _jsx(SliderWrapper, { children: _jsxs(SliderTrack, { children: [_jsx(SliderFill, { style: { left: "".concat(left * 100, "%"), right: "".concat((1 - right) * 100, "%") } }), _jsxs(SliderHandle, { onMouseDown: function (event) { return handleDown(event, CursorType.MIN); }, onTouchStart: function (event) { return handleDown(event, CursorType.MIN); }, style: {
                            left: "".concat(left * 100, "%"),
                            zIndex: activeCursor === CursorType.MIN ? 2 : 1,
                        }, children: [_jsx("div", {}), _jsx("p", { className: "number", children: minValue })] }), _jsxs(SliderHandle, { onMouseDown: function (event) { return handleDown(event, CursorType.MAX); }, onTouchStart: function (event) { return handleDown(event, CursorType.MAX); }, style: {
                            left: "".concat(right * 100, "%"),
                            zIndex: activeCursor === CursorType.MAX ? 2 : 1,
                        }, textBottom: true, children: [_jsx("div", {}), _jsx("p", { className: "number", children: maxValue })] })] }) }) }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n"])));
var SliderWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n"], ["\n  position: relative;\n  width: 100%;\n"])));
var SliderTrack = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 2px;\n  cursor: pointer;\n  height: 4px;\n  position: relative;\n  width: 100%;\n"], ["\n  background-color: ", ";\n  border-radius: 2px;\n  cursor: pointer;\n  height: 4px;\n  position: relative;\n  width: 100%;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.layoutCardLight;
});
var SliderFill = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 2px;\n  height: 100%;\n  position: absolute;\n"], ["\n  background-color: ", ";\n  border-radius: 2px;\n  height: 100%;\n  position: absolute;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.purple;
});
var SliderHandle = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 50%;\n  cursor: grab;\n  height: 20px;\n  position: absolute;\n  top: -8px;\n  transform: translateX(-50%);\n  transition: background-color 0.2s ease;\n  padding: 4px;\n  width: 20px;\n\n  & div {\n    background-color: rgba(0, 0, 0, 0.2);\n    border-radius: 50%;\n    height: 100%;\n    width: 100%;\n  }\n\n  &:active {\n    cursor: grabbing;\n  }\n\n  & > p {\n    bottom: ", ";\n    font-size: 16px;\n    left: 50%;\n    position: absolute;\n    top: ", ";\n    transform: translateX(-50%);\n    user-select: none;\n    white-space: nowrap;\n  }\n"], ["\n  background-color: ", ";\n  border-radius: 50%;\n  cursor: grab;\n  height: 20px;\n  position: absolute;\n  top: -8px;\n  transform: translateX(-50%);\n  transition: background-color 0.2s ease;\n  padding: 4px;\n  width: 20px;\n\n  & div {\n    background-color: rgba(0, 0, 0, 0.2);\n    border-radius: 50%;\n    height: 100%;\n    width: 100%;\n  }\n\n  &:active {\n    cursor: grabbing;\n  }\n\n  & > p {\n    bottom: ", ";\n    font-size: 16px;\n    left: 50%;\n    position: absolute;\n    top: ", ";\n    transform: translateX(-50%);\n    user-select: none;\n    white-space: nowrap;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.purple;
}, function (_a) {
    var textBottom = _a.textBottom;
    return (textBottom ? '-24px' : 'auto');
}, function (_a) {
    var textBottom = _a.textBottom;
    return (textBottom ? 'auto' : '-22px');
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
